export default __webpack_public_path__ + "static/media/1st-bg.07045895.svg";